(() => {
  const compact = (root, selector) => {
    const choices = [...root.querySelectorAll(selector)].filter(e => !e.hasAttribute('data-z-colour-more'));
    if (choices.length < 2) return;
    let more = root.querySelector('[data-z-colour-more]');
    if (!more) {
      more = document.createElement('button'); more.type = 'button'; more.dataset.zColourMore = '';
      more.className = 'z-colour-more';
      more.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        root.dataset.expanded = String(root.dataset.expanded !== 'true'); update();
      });
      root.append(more);
    }
    const update = () => {
      const cardWidth = root.closest('.grid__item,.zv7-card')?.clientWidth || Infinity;
      const width = Math.min(root.clientWidth || 240,cardWidth);
      const limit = Math.max(1, Math.min(4, Math.floor(width / 44) - 1));
      const shown = choices.slice(0, limit);
      const selected = choices.find(e => e.getAttribute('aria-current') === 'true' || e.getAttribute('aria-pressed') === 'true');
      if (selected && !shown.includes(selected)) shown[shown.length - 1] = selected;
      const expanded = root.dataset.expanded === 'true';
      choices.forEach(e => { e.hidden = !expanded && !shown.includes(e); });
      more.hidden = choices.length <= limit;
      more.textContent = expanded ? '-' : '+' + (choices.length - limit);
      more.setAttribute('aria-expanded', String(expanded));
      more.setAttribute('aria-label', expanded ? 'Show fewer colours' : 'Show ' + (choices.length - limit) + ' more colours');
      root.classList.add('z-colours-compact');
    };
    root._zCompactUpdate = update;
    root._zCompactObserver ||= new ResizeObserver(() => root._zCompactUpdate());
    root._zCompactObserver.observe(root); update();
  };
  const preload = new Map();
  const ready = src => {
    if (!preload.has(src)) {
      const img = new Image(); img.src = src;
      preload.set(src, img.decode().catch(error => { preload.delete(src); throw error; }));
    }
    return preload.get(src);
  };
  const preview = (card, image, secondary, choices) => {
    let original, version = 0;
    const restore = () => {
      version++;
      if (!original) return;
      for (const [key, value] of Object.entries(original.attributes)) value === null ? image.removeAttribute(key) : image.setAttribute(key, value);
      if (secondary) original.secondaryStyle === null ? secondary.removeAttribute('style') : secondary.setAttribute('style', original.secondaryStyle);
      delete card.dataset.zColourPreview; original = null;
    };
    for (const {control, image:src} of choices) {
      if (!src) continue;
      const show = async () => {
        const ticket = ++version;
        try { await ready(src); } catch { return; }
        if (ticket !== version || !card.isConnected) return;
        original ||= {attributes:Object.fromEntries(['src','srcset','style','alt'].map(key => [key,image.getAttribute(key)])), secondaryStyle:secondary?.getAttribute('style') ?? null};
        image.removeAttribute('srcset'); image.src = src; image.style.opacity = '1';
        if (secondary) secondary.style.opacity = '0';
        card.dataset.zColourPreview = 'true';
      };
      control.addEventListener('pointerenter', show); control.addEventListener('focus', show);
      control.addEventListener('pointerleave', restore); control.addEventListener('blur', restore);
    }
    return restore;
  };
  const safeHover = card => {
    if (card.dataset.zSafeHover) return;
    card.dataset.zSafeHover = 'true';
    let version=0;
    const prepare=async()=>{
      const image=card.querySelector('.card__media .media > img:nth-child(2),.zv7-card__secondary');
      const ticket=++version;
      delete card.dataset.zSecondaryReady;
      if(!image||image.style.display==='none')return;
      const source=image.src+'|'+image.srcset;
      try { await image.decode(); } catch { return; }
      if(ticket===version&&image.isConnected&&image.complete&&image.naturalWidth>0&&source===image.src+'|'+image.srcset)card.dataset.zSecondaryReady='true';
    };
    card.addEventListener('pointerenter',prepare);
    card.addEventListener('focusin',prepare);
    card.addEventListener('zico:media-changed',prepare);
    const secondary=card.querySelector('.card__media .media > img:nth-child(2),.zv7-card__secondary');
    if(secondary) {
      secondary.addEventListener('error',()=>{version++;delete card.dataset.zSecondaryReady;});
      secondary.addEventListener('load',prepare);
      new MutationObserver(prepare).observe(secondary,{attributes:true,attributeFilter:['src','srcset']});
    }
  };
  const mount = scope => {
    if(scope.matches?.('product-component,.zv7-card'))safeHover(scope);
    scope.querySelectorAll('product-component,.zv7-card').forEach(safeHover);
    homes(scope);
  };
  window.ZicoCardColours = {compact, preview, ready, safeHover};
  const homes = scope => scope.querySelectorAll('.z-home-colours').forEach(root => {
    if (root.dataset.zColourUi) return; root.dataset.zColourUi = 'true';
    compact(root, 'a');
    const card = root.closest('.zv7-card'), image = card?.querySelector('.zv7-card__primary');
    if (image) preview(card, image, card.querySelector('.zv7-card__secondary'), [...root.querySelectorAll('a')].map(control => ({control,image:control.dataset.primary})));
  });
  mount(document);
  document.addEventListener('zico:products-appended', event => mount(event.detail.scope));
  document.addEventListener('shopify:section:load', event => mount(event.target));
  const content=document.getElementById('MainContent');
  if(content)new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)mount(node);}))).observe(content,{childList:true,subtree:true});
})();

